import React from 'react'
import mainBG from '../../../assets/EinführungMainBG.png'
import ellipseBG from '../../../assets/EllipseBG.png'
import { useTranslation } from "react-i18next";
const FirstForm = ({ nextClick, backClick }) => {
    const { t } = useTranslation()
    return (
        <>
            <div style={{ background: `url(${mainBG})` }} className='h-screen !bg-cover !bg-no-repeat !bg-center flex flex-col justify-between'>
                <div></div>

                <div style={{ background: `url(${ellipseBG})` }} className='min-h-[75vh] !bg-cover !bg-no-repeat !bg-top relative'>
                    <div className='relative py-32 w-full max-w-[36rem] mx-auto flex flex-col justify-between h-full justify-self-center text-center pb-4'>
                        <h1 className='font-normal text-lg text-[#fff] mx-4'>{t(`s-3-desc`)}</h1>
                        <div className='pt-4 flex gap-6 mx-4 flex-col-reverse sm:flex-row'>
                            <button className='w-full button_primary' onClick={backClick} >{t(`s-2-btn1`)}</button>
                            <button className='w-full button_secodry' onClick={nextClick} >{t(`s-2-btn2`)}</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default FirstForm